var objectify = require('./objectifier');

module.exports = function (result) {
    if ( console && console.warn ) {
        result.warnings().forEach(function (warn) {
            var source = warn.plugin || 'PostCSS';
            console.warn(source + ': ' + warn.text);
        });
    }
    return objectify(result.root);
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/postcss-js/process-result.js
 ** module id = 458
 ** module chunks = 0
 **/